import React from 'react'
import LazyImg from "../LazyImg";

function TestimonialItem({src, authorName, label, description}) {
    return (

        <div className="testimonial-item">
            <p className='mb-25'>{description}</p>

            <div className="author-box">
                {src && <span className="avatar">
                    <LazyImg className='cover-bg-img' src={src} alt={authorName}/>
                </span>}
                {authorName && <h5 className="auth-info">{authorName}</h5>}
                {label && <span className="label">{label}</span>}

            </div>
        </div>
    )
}


export default TestimonialItem;